import React, { useEffect, useRef } from "react";
import { useState } from "react";
import styled from "styled-components";
import { useParams } from "react-router";
import { NFT_LIST, NFT_BUYERS,
         USER_PERK, CLAIMABLE_PERKS } from "../constants/urls";
import NFTNav from "../components/NavComponents/NFTNav";
import Card from "../components/desktop/Card";
import StreamPowerImageComponent from "../components/StreamPowerComponents/StreamImageComponent";
import EarlyAccessFooter from "../components/desktop/EarlyAccessFooter";
import ModalBidComponent from "../components/BidComponents/PlaceBidModalComponent";
import PowersListComponent from "../components/StreamPowerComponents/PowersListComponent";
import {
    useHistory,
} from "react-router-dom/cjs/react-router-dom.min";
import twitch from '../assets/twitch.svg';
import box_frame from '../assets/box_frame.png';
import supermessage from '../assets/powers/supermessage.png';
import flashbang from '../assets/powers/flashbang.png';
import autograph from '../assets/powers/autograph.png';
import supermessage_asset from '../assets/powers/supermessage_asset.png';
import flashbang_asset from '../assets/powers/flashbang_asset.png';
import autograph_asset from '../assets/powers/autograph_asset.png';
import eventBus from '../utils/globalPubSub';
import {
    fetchUserDirectPerks,
    convertUserDirectPerksToDict} from '../utils/perksUtils';
import {fetchPaymentConfigFromBackend} from '../utils/backendUtils';

import { PaymentContext } from '../utils/paymentConfigProvider';

const CoinGecko = require('coingecko-api');
const CoinGeckoClient = new CoinGecko();


const url = window.location;
let domain = (new URL(url));
domain = domain.origin;


const Mobile = styled.div`
  display: none;
  background: #000;
  @media only screen and (max-device-width: 480px) {
    display: flex;
    flex-direction: column;
  }
`;

const CollectorsTitle = styled.div`
  margin-top: 65px;
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 90.1%;
  /* identical to box height, or 38px */

  display: flex;
  align-items: center;

  color: ${props => props.active ? '#FFFFFF': 'rgba(255,255,255,0.45)'};
  margin: 4px;

  text-shadow: 0px 4px 20px rgba(0, 0, 0, 0.4);
  text-align: center;
  margin-top: 36px;
`;

const Desktop = styled.div`
  display: none;
  background: #000;
  @media (min-device-width: 481px) {
  display: flex;
  flex-direction: column;
  /* height: 100vh; */
  height: 100%;
  /* overflow: hidden; */
  }
`;

const Container = styled.div`
  padding: 12px 300px;
  display: flex;
  flex-direction: column;
  /* overflow: scroll; */
  /* height: 100vh; */
`;


const CollectorAddress = styled.div`
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-weight: bold;
  font-size: 32px;
  line-height: 90.1%;
  display: flex;
  align-items: center;
  color: #FFFFFF;
  text-shadow: 0px 4px 20px rgba(0, 0, 0, 0.4);
  margin-bottom: 10px;
`;

const CollectorBoughtTime = styled.div`
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #FFFFFF;
  opacity: 0.4;
`;

const Perks = styled.div`
  font-family: 'Space Mono';
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 90.1%;
  color: #FFFFFF;
`;


const CollectorItemBought = styled.a`
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #FFFFFF;
  opacity: 0.4;
`;


const BlankHeader = styled.div`
    font-family: 'IBM Plex Mono', monospace;
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    line-height: 110%;
    /* or 40px */

    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    margin-top: 85px;

`;

const ProfileHeaderWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    padding-bottom: 20px;
    margin-top: 44px;
`;


const ProfileHeader = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

const Username = styled.div`    
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    line-height: 90.1%;
    /* or 25px */
    text-transform: uppercase;
    color: #FFFFFF;
`;


const ProfileData = styled.div`
    display: flex;
    display: none;
    flex-direction: row;
    justify-content: flex-end;
    @media only screen and (max-device-width: 480px) {
        justify-content: flex-start;
    }
`;


const ProfileDataHeader = styled.div`
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    /* identical to box height */

    display: flex;
    align-items: center;
    text-align: center;

    color: #FFFFFF;

    opacity: 0.4;
    text-align: center;
    display: flex;
    justify-content: center;
`;


const ProfileDataValue = styled.div`
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 26px;
    /* identical to box height */

    display: flex;
    align-items: center;

    color: #FFFFFF;
    text-align: center;
    display: flex;
    justify-content: center;
`;

const HypeBoxTitle = styled.div`
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    line-height: 90.1%;
    /* or 25px */

    text-transform: uppercase;

    color: #FFFFFF;
`;

const HypeBoxLive = styled.div`

    background: linear-gradient(95.39deg, #FE0000 3.78%, #FA00FF 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
    margin-top: 12px;
`;

const HypeBoxHeader = styled.div`
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    /* identical to box height */

    display: flex;
    align-items: center;
    text-align: center;

    color: #FFFFFF;

    opacity: 0.4;
    text-align: center;
    display: flex;
    justify-content: flex-start;
`;


const HypeBoxValue = styled.div`
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 26px;
    /* identical to box height */

    display: flex;
    align-items: center;
    color: #FFFFFF;
    text-align: center;
    display: flex;
    justify-content: flex-start;
`;

const WhiteButton = styled.div`
    padding: 12px 16px;
    background: #FFFFFF;
    border-radius: 12px;
    color: #000;
    width: 140px;
    display: flex;
    justify-content: center;
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;

    color: #000000;
    margin-top: 20px;
`;

const GreenButton = styled.div`
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;

    color: #FFFFFF;
    padding: 10px;
    position: relative;
    z-index: 1;
    background: rgba(0, 126, 34, 1);
    background-blend-mode: overlay;
    border-radius: 12px;
`;


const LightPurpleButton = styled.div`
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;

    color: #FFFFFF;
    padding: 10px;
    position: relative;
    z-index: 1;
    background: rgba(151, 32, 228, 1);
    background-blend-mode: overlay;

    border-radius: 12px;
`;


const PurpleButton = styled.div`
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;

    color: #FFFFFF;
    padding: 10px;
    position: relative;
    z-index: 1;
    background: #650054;
    border-radius: 12px;
`;


const PowersWrapper = styled.div`
    padding-bottom: 40px;
    border-bottom: 1px solid rgba(255,255,255,0.08);
    margin-bottom: 25px;
`;


const PowersStock = styled.div`
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 150%;
    /* identical to box height, or 21px */

    letter-spacing: 0.05em;
    text-transform: uppercase;

    color: #FFFFFF;
    margin-top: 14px;
`;

const PowersTitle = styled.div`
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 90.1%;
    /* or 18px */

    text-align: center;

    color: #FFFFFF;
    margin-top: 8px;
`;

const PowerPrice = styled.div`
    font-family: 'Chakra Petch';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;

    color: #FFFFFF;
    margin-top: 8px;
`;

const DesktopList = styled.div`
@media only screen and (max-device-width: 480px) {
    margin: 0px!important;
  }
`;

const CtaButton = ({ count, img }) => {
    return (
	<a onClick={() => {
	    setOpen(true);
	    console.log(open);
	    window.analytics.track('modal_open_cta_clicked', {
		icon: `${img}`,
	    })    
	}}
	   style={{ textAlign: "center" }}
	>
	    <img src={img} />
	    <div style={{ textAlign: "center", marginBottom: 16 }}>{count}</div>
	</a>
    );
};


function useForceUpdate(){
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update the state to force render
}

export default function UserStore(props) {
    
    const [data, dataSet] = useState();
    const [activeTab, setActiveTab] = useState('NFT');
    const [perks, setPerks] = useState([]);
    const [powers, setPowers] = useState([]);
    const [freePowers, setFreePowers] = useState([]);
    const history = useHistory();
    
    
    const paymentConfig = useRef({});
    
    const setPaymentConfig = (newVal, key) => {
        console.log('paymentConfig.current', newVal);
        if(key){paymentConfig.current[key] = newVal;}
        forceUpdate();
    }
    
    
    const forceUpdate = useForceUpdate();
    const { username } = useParams();

    const [ownedPerksDict, setOwnedPerksDict] = useState({});


    const fetchPaymentConfig = async () => {
        let paymentConfig = await fetchPaymentConfigFromBackend(
            username);
        console.log(
            'paymentConfigpaymentConfig',
            paymentConfig.data);
        setPaymentConfig(paymentConfig.data, 'creatorConfig');
    }

    useEffect(()=>{
        eventBus.on('free-perk-claimed', async ()=>{
            console.log('bdadjklhasdjkhas');
            await fetchDirectUserPerksFromBackend(username);
            await fetchFreePowers();
        })
        return ()=>{
            eventBus.remove("free-perk-claimed");
        }
    },[]);

    
    const fetchDirectUserPerksFromBackend = async (username:any)=>{
        let userDirectPerks:any = await fetchUserDirectPerks(
            username);
        if(!userDirectPerks){
            return;
        }
        console.log('userDirectPerks',
                    userDirectPerks.data.directUserPerks[0]);
        let userPerksDict = convertUserDirectPerksToDict(
                userDirectPerks.data.directUserPerks);
        setOwnedPerksDict(userPerksDict);
    }

    
    useEffect(() => {
        (async()=>{
            fetchDirectUserPerksFromBackend(username);
        })();
    }, [username]);

    async function fetchMyAPI() {
        // TODO Change endpoint
        let response = await fetch(
            USER_PERK + `?username=${username}`);
        //let response = await fetch(USER_PERK + `?userId=244`);
        response = await response.json();        
        if(response.data) {
            console.log(response.data.perks, '=================perks');
            setPowers(response.data.perks);
            dataSet(true);
        }
    }

    async function fetchFreePowers() {
        // TODO Change endpoint
        let response = await fetch(
            CLAIMABLE_PERKS + `?creatorName=${username}`);
        //let response = await fetch(USER_PERK + `?userId=244`);
        response = await response.json();
        console.log('wwwwww', response);
        if(response.data) {
            console.log(response.data, '=================perks');
            setFreePowers(response.data.claimablePerks);
            dataSet(true);
        }
    }
    
    useEffect(() => {
	fetchMyAPI();
        fetchFreePowers();
        fetchPaymentConfig();
    }, []);
                    
    
    if (!data) {
        return <>
            <Desktop>
                <NFTNav
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    creator={username}
                    userChainId={1}
                    showTabs={false}
                    expanded={false}
                />
            </Desktop>
        </>;
    }
    
    return (
	<PaymentContext.Provider value={paymentConfig.current}>
            <NFTNav
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                creator={username}
                handleWithdrawClicked={()=>{handleWithdrawClicked()}}
                handleDepositClicked={()=>{handleDepositClicked()}}
                userChainId={data.creatorChainId}
                showTabs={true}
                expanded={false}
            />
            <Mobile>
                <div style={{padding: 26}}>
                    {(freePowers) && (
                        <PowersWrapper style={{marginBottom:10}}>
                            <Username>{username}'s Free powers</Username>
                            <br></br>
                            <div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center'}}>
                                <PowersListComponent
                                    username={username}
                                    powers={freePowers}
                                    free={true}
                                    ownedPerksDict={ownedPerksDict}
                                >
                                </PowersListComponent>
                            </div>
                        </PowersWrapper>
                    )}
                    <Username>{username} POWERS</Username>
                    <ProfileData>
                        <div style={{display: 'flex', border: '1px solid rgba(255, 255, 255, 0.08)', borderRadius: 12}}>
                            <div style={{padding: '12px 20px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', textAlign: 'center'}}>
                                <ProfileDataHeader>EARNINGS</ProfileDataHeader>
                                <ProfileDataValue>240$</ProfileDataValue>
                            </div>
                            <div style={{borderLeft: '1px solid rgba(255, 255, 255, 0.08)', padding: '12px 20px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', textAlign: 'center', background: 'rgba(255, 255, 255, 0.02)'}}>
                                <ProfileDataHeader>ITEMS SOLD</ProfileDataHeader>
                                <ProfileDataValue>6</ProfileDataValue>
                            </div>
                            <div style={{borderLeft: '1px solid rgba(255, 255, 255, 0.08)', padding: '12px 20px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', textAlign: 'center'}}>
                                <ProfileDataHeader>IN STOCK</ProfileDataHeader>
                                <ProfileDataValue>58</ProfileDataValue>
                            </div>
                        </div>
                    </ProfileData>
                    <br></br>

                    <br></br>
                    <div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center'}}>
                        <PowersListComponent
                            username={username}
                            powers={powers}
                            ownedPerksDict={ownedPerksDict}
                            mobile={true}
                        >
                        </PowersListComponent>
                    </div>

                </div>
            </Mobile>
	    <Desktop>

                <Container>
                    {(freePowers.length>0) && (
                        <PowersWrapper style={{marginBottom:0}}>
                            <Username>{username}'s Free powers</Username>
                            <div style={{display: 'flex', marginLeft: -20, marginTop: 24, flexWrap: 'wrap'}}>
                                <PowersListComponent
                                    username={username}
                                    powers={freePowers}
                                    ownedPerksDict={ownedPerksDict}
                                    free={true}
                                >
                                </PowersListComponent>
                            </div>
                        </PowersWrapper>
                    )}
                    <ProfileHeaderWrapper>
                        <ProfileHeader>
                            <div style={{display: 'flex', marginTop: 34}}>
                                <Username>{username}'s STORE</Username>
                                <a href={`https://twitch.tv/${username}`}>
                                    <img src={twitch} style={{marginLeft: 8}} />
                                </a>
                            </div>
                        </ProfileHeader>
                        <ProfileData>
                            <div style={{display: 'flex', border: '1px solid rgba(255, 255, 255, 0.08)', borderRadius: 12}}>
                                <div style={{padding: '12px 20px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', textAlign: 'center'}}>
                                    <ProfileDataHeader>EARNINGS</ProfileDataHeader>
                                    <ProfileDataValue>240$</ProfileDataValue>
                                </div>
                                <div style={{borderLeft: '1px solid rgba(255, 255, 255, 0.08)', padding: '12px 20px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', textAlign: 'center', background: 'rgba(255, 255, 255, 0.02)'}}>
                                    <ProfileDataHeader>ITEMS SOLD</ProfileDataHeader>
                                    <ProfileDataValue>6</ProfileDataValue>
                                </div>
                                <div style={{borderLeft: '1px solid rgba(255, 255, 255, 0.08)', padding: '12px 20px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', textAlign: 'center'}}>
                                    <ProfileDataHeader>IN STOCK</ProfileDataHeader>
                                    <ProfileDataValue>58</ProfileDataValue>
                                </div>
                            </div>
                        </ProfileData>
                    </ProfileHeaderWrapper>
                    <PowersWrapper>
                        <div style={{display: 'flex', marginLeft: -20, marginTop: 24, flexWrap: 'wrap'}}>
                            <PowersListComponent
                                username={username}
                                powers={powers}
                                ownedPerksDict={ownedPerksDict}
                            >
                            </PowersListComponent>
                        </div>
                    </PowersWrapper>
                </Container>		
                <EarlyAccessFooter />
	    </Desktop>
	</PaymentContext.Provider>
    );
}

